import React from "react";

export const activeOrderLink = (sort, callBack) => {

    let sortPublished = 'btn-default';
    let sortLike = 'btn-default';
    let sordView = 'btn-default';

    if (sort == undefined || sort == '' || sort == 'published') {

        sortPublished = 'btn-primary';

    } else {

        if(sort == 'like') { sortLike = 'btn-primary';}

        if(sort == 'view') { sordView = 'btn-primary'; }
    }

    return (
        <div className="order-link">
            <button id="sortPublished"  className={`btn btn-sort btn-sm ${sortPublished}`} onClick={() => callBack('published')}> Most Recent</button>
            <button id="sortLike" className={`btn btn-sort btn-sm ${sortLike}`}  onClick={() => callBack('like')}> Top Rated</button>
            <button id="sordView" className={`btn btn-sort btn-sm ${sordView}`}  onClick={() => callBack('view')}> Most Viewed</button>
		</div>
    )
}


export const sortPopular = (sort, callBack) => {

    let sortPublished = 'btn-default';
    let sortLike = 'btn-default';
    let sordView = 'btn-default';

    if (sort == undefined || sort == '' || sort == 'day') {

        sortPublished = 'btn-primary';

    } else {

        if(sort == 'week') { sortLike = 'btn-primary';}

        if(sort == 'month') { sordView = 'btn-primary'; }
    }

    return (
        <div className="order-link">
            <button id="sortPublished"  className={`btn btn-sort btn-sm ${sortPublished}`} onClick={() => callBack('')}> Day</button>
            <button id="sortLike" className={`btn btn-sort btn-sm ${sortLike}`}  onClick={() => callBack('week')}> Week</button>
            <button id="sordView" className={`btn btn-sort btn-sm ${sordView}`}  onClick={() => callBack('month')}> Month</button>
        </div>
    )

}
